import {RouteMapType} from "@/type/common/route/RouteMapType";
import {FORMEDGE_SERVICE_PAGE_URL} from "@/functions/formedgeLink";

export const routeMap = {
    "home": {
        icon: "mdi-home",
        path: "/",
        title: "Home",
        label: "ホーム"
    },
    "service": {
        icon: "mdi-rocket-launch-outline",
        path: FORMEDGE_SERVICE_PAGE_URL,
        title: "Service",
        label: "サービス",
        external: true
    },
    "message": {
        icon: "mdi-account-tie-voice",
        path: "/message",
        title: "Message",
        label: "代表挨拶"
    },
    "culture": {
        icon: "mdi-hand-heart-outline",
        path: "/recruit/culture",
        title: "Culture",
        label: "文化・働く環境"
    },
    "recruit": {
        icon: "mdi-account-multiple",
        path: "/recruit",
        title: "Recruit",
        label: "採用情報"
    },
    "access": {
        icon: "mdi-map-marker",
        path: "/access",
        title: "Access",
        label: "所在地・路線"
    },
    "security": {
        icon: "mdi-shield-check-outline",
        path: "/security-policy",
        title: "Security & Privacy",
        label: "情報セキュリティ・個人情報保護"
    }
} as const
;

export const routeMaps: RouteMapType[] = [
    routeMap.home,
    routeMap.service,
    routeMap.message,
    routeMap.culture,
    routeMap.recruit,
    routeMap.access,
    routeMap.security,
];
